module.exports = __webpack_public_path__ + "assets/img/Currency2.561d656a.png";